import Types from "./Types";

const INIT_STATE = {
  eventTypes: [],
  filterEventTypes: [],
  eventType: {},
  services: [],
  availableServices: [],
  availableServicesCount: 0,
  count: 0,
  listCount: 0,
  load: null,
  error: null,
};

export function eventTypesReducer(state = INIT_STATE, action) {
  const { type, payload } = action;
  switch (type) {
    case Types.EVENT_TYPES_LOADING: {
      return {
        ...state,
        load: payload,
      };
    }
    case Types.GET_EVENT_TYPES_SUCCESS: {
      return {
        ...state,
        eventTypes: payload?.data?.event_types || [],
        count: payload?.extra?.total_count,
      };
    }
    case Types.GET_SCROLL_EVENT_TYPES_SUCCESS: {
      return {
        ...state,
        filterEventTypes:
          payload?.extra?.page_number == 1
            ? payload?.data?.event_types || []
            : [
                ...state.filterEventTypes,
                ...(payload?.data?.event_types || []),
              ],
        listCount: payload?.extra?.total_count,
      };
    }
    case Types.GET_EVENT_TYPE_DETAILS_SUCCESS: {
      const eventType = payload?.data?.event_type || {};
      return {
        ...state,
        eventType,
        services: eventType?.services || state.services,
      };
    }
    case Types.GET_EVENT_TYPE_SERVICES_SUCCESS: {
      return {
        ...state,
        services:
          payload?.data?.services ||
          payload?.data?.event_type?.services ||
          [],
      };
    }
    case Types.GET_AVAILABLE_EVENT_SERVICES_SUCCESS: {
      const list =
        payload?.data?.services ||
        payload?.data?.products ||
        [];
      return {
        ...state,
        availableServices:
          payload?.extra?.page_number == 1
            ? list
            : [...state.availableServices, ...list],
        availableServicesCount: payload?.extra?.total_count,
      };
    }
    default:
      return state;
  }
}
